import React, { Component } from "react";
import { connect } from "react-redux";
import BulkVerificationList from "../VerificationJobsList/BulkVerificationList";
import SingleVerificationList from "../VerificationJobsList/SingleVerificationList";
import VerificationListSelection from "../VerificationJobsList/VerificationListSelection";
import {
  loadSigleEmail,
  switchTab,
} from "../../../Containers/EmailValidation/actions";
import Session from "../../../utility/session";
const mapStateToProps = (state) => ({
  singleEmailVerificationResults: state.emailverificationinfo,
  singleEmailData:state.singleEmailData,
  validateEmail: state.validateEmail,
});
class VerifiedJobsContainer extends Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
    this.switchTab = this.switchTab.bind(this);
  }
  handleClick(e) {
    this.props.dispatch(
      loadSigleEmail({ username: Session.getItem("current_username"), page:1 })
    );
  }
  switchTab(tab) {
    this.props.dispatch(switchTab(tab));
  }
  componentWillReceiveProps() {
    const status = this.props.validateEmail.status;
    // if (status === 0) {
    //   console.log(`Triggered here`)
    //   this.props.dispatch(
    //     loadSigleEmail({ username: Session.getItem("current_username") })
    //   );
    // }
  }

  render() {
    const switch_tab = this.props.singleEmailVerificationResults.viewState;

    return (
      <div className="emailVerification col-md-12">
        <div className="x_panel">
          <div className="x_title">
            <VerificationListSelection />
          </div>

          <div className="" role="tabpanel">
            <ul id="myTab" className="nav nav-tabs bar_tabs" role="tablist">
              <li
                role="presentation"
                className={switch_tab == "bulk" ? "active" : null}
                onClick={e => this.switchTab("bulk")}
              >
                <a
                  href="#tab_content1"
                  id="home-tab"
                  role="tab"
                  data-toggle="tab"
                  aria-expanded="true"
                >
                  Bulk email verification
                </a>
              </li>
              <li
                role="presentation"
                className={switch_tab == "single" ? "active" : null}
                onClick={e => this.switchTab("single")}
              >
                <a
                  href="#tab_content2"
                  role="tab"
                  id="profile-tab"
                  data-toggle="tab"
                  aria-expanded="false"
                  onClick={this.handleClick}
                >
                  Single email verification
                </a>
              </li>
            </ul>

            <div id="myTabContent" className="tab-content">
              {switch_tab == "bulk" ? (
                <BulkVerificationList />
              ) : (
                <SingleVerificationList
                // singleEmailVerificationResults={this.props.singleEmailVerificationResults}
                // singleEmailData={this.props.singleEmailData}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(mapStateToProps)(VerifiedJobsContainer);



// WEBPACK FOOTER //
// ./src/components/EmailVerification/EmailVerificationContainer/EmailVerificationJobs.js